import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {center} from '../../../../libs/shared/ui/src/styles/mixins';
import emptySearch from '../../../assets/images/emptySearch70.svg';

/*
 * Props.
 */

interface SchedulingLinksSearchEmptyProps {}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  height: 100%;
  ${center()};
`;

const StyledImageDiv = styled.div`
  width: 70px;
  height: 70px;

  background-image: url(${emptySearch});
  background-position: center center;
`;

const StyledLabelDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  margin-top: 12px;
`;

/*
 * Component.
 */

export const SchedulingLinksSearchEmpty: FC<SchedulingLinksSearchEmptyProps> = (props) => (
  <StyledWrapperDiv>
    <StyledImageDiv />
    <StyledLabelDiv>
      <Trans id="schedulinglinks-search-noresults">No results</Trans>
    </StyledLabelDiv>
  </StyledWrapperDiv>
);
